<!-- <div class="d-flex">
    <div class=" nav-tabs">
        <ng-container *ngIf="employee_details?.designation === 'Caratred Supervisor'">
            <div routerLink="company" routerLinkActive="active">
                <i class="ri-building-line"></i>
                <p>Company</p>
            </div>
            <div routerLink="modules" routerLinkActive="active">
                <i class="ri-layout-grid-2-line"></i>
                <p>Modules</p>
            </div>
        </ng-container>
        <ng-container *ngIf="employee_details?.designation !== 'Caratred Supervisor'">
            <div routerLink="products" routerLinkActive="active">
                <i class="ri-layout-grid-2-line"></i>
                <p>Products</p>
            </div>
        </ng-container>
        <div routerLink="users" routerLinkActive="active">
            <i class="ri-user-3-line"></i>
            <p>Employees</p>
        </div>
        <div routerLink="roles" routerLinkActive="active">
            <i class="ri-id-card-fill"></i>
            <p>Roles</p>
        </div>
        <div routerLink="department" routerLinkActive="active">
            <i class="ri-git-merge-line"></i>
            <p>Department</p>
        </div>
        <div routerLink="permissions" routerLinkActive="active">
            <i class="ri-key-fill"></i>
            <p>Permissions</p>
        </div>
        <div routerLink="settings" routerLinkActive="active">
            <i class="ri-settings-4-line"></i>
            <p>Settings</p>
        </div>
        <div>
            <i class="ri-menu-fold-line"></i>
        </div>
    </div>
    <div class="w-100 mx-4">
        <router-outlet></router-outlet>
    </div>
</div> -->


<!-- <div class="container-fluid pl-0">
    <div class="row">
        <div class="col-md-2 pr-0 nav-box-shadow">
            <div class=" nav-tabs">
                <ng-container *ngIf="employee_details?.designation === 'Caratred Supervisor'">
                    <div routerLink="company" routerLinkActive="active">

                        <p class="m-0 d-flex align-items-center"> <i class="ri-building-line px-2"></i> Company</p>
                    </div>
                    <div routerLink="modules" routerLinkActive="active">

                        <p class="m-0 d-flex align-items-center"> <i class="ri-layout-grid-2-line px-2"></i> Modules</p>
                    </div>
                </ng-container>
                <ng-container *ngIf="employee_details?.designation !== 'Caratred Supervisor'">
                    <div routerLink="products" routerLinkActive="active">

                        <p class="m-0 d-flex align-items-center"> <i class="ri-layout-grid-2-line px-2"></i> Products
                        </p>
                    </div>
                </ng-container>
                <div routerLink="users" routerLinkActive="active">

                    <p class="m-0 d-flex align-items-center"><i class="ri-user-3-line px-2"></i> Employees</p>
                </div>
                <div routerLink="roles" routerLinkActive="active">

                    <p class="m-0 d-flex align-items-center"> <i class="ri-id-card-fill px-2"></i> Roles</p>
                </div>
                <div routerLink="department" routerLinkActive="active">

                    <p class="m-0 d-flex align-items-center"><i class="ri-git-merge-line px-2"></i> Department</p>
                </div>
                <div routerLink="permissions" routerLinkActive="active">

                    <p class="m-0 d-flex align-items-center"> <i class="ri-key-fill px-2"></i> Permissions</p>
                </div>
                <div routerLink="settings" routerLinkActive="active">

                    <p class="m-0 d-flex align-items-center"><i class="ri-settings-4-line px-2"></i> Settings</p>
                </div>
                <div>
                    <i class="ri-menu-fold-line"></i>
                </div>
            </div>
        </div>
        <div class="col-md-10">
            <router-outlet></router-outlet>
        </div>
    </div>
</div> -->

<!-- <div class="container-fluid pl-0">
  <div class="row">
    <div [ngClass]="{'col-md-1': isCollapsed, 'col-md-2': !isCollapsed}" class="pr-0 nav-box-shadow sidebar">
     
    </div>

    <div [ngClass]="{'col-md-11': isCollapsed, 'col-md-10': !isCollapsed}">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->


<div class="main-layout d-flex">
  <!-- Sidebar -->
  <div  class="sidebar d-flex flex-column justify-content-between d-none" 
    (mouseenter)="onSidebarHover(true)" (mouseleave)="onSidebarHover(false)"  [class.open]="!isCollapsed">
     <div (click)="toggleSidebar()" class="shownav">
       <i class="ri-grid-fill  cursor-pointer"></i>
     </div>
    <!-- Navigation Items -->
    <div class="nav-tabs nav-box-shadow" [class.collapsed]="isCollapsed">
      <ng-container *ngIf="employee_details?.designation === 'Caratred Supervisor'">
        <div routerLink="company" routerLinkActive="active" class="nav-item" placement="end"
          [ngbTooltip]="(isCollapsed ) ? 'Company' : null"  (click)="closeSidebar()">
          <p class="m-0 d-flex align-items-center">
            <i class="ri-building-line px-2"
              [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
            <span *ngIf="!isCollapsed ">Company</span>
          </p>
        </div>
        <div routerLink="modules" routerLinkActive="active" class="nav-item" placement="end"
          [ngbTooltip]="(isCollapsed ) ? 'Modules' : null"  (click)="closeSidebar()">
          <p class="m-0 d-flex align-items-center ">
            <i class="ri-layout-grid-2-line px-2"
              [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
            <span *ngIf="!isCollapsed ">Modules</span>
          </p>
        </div>
        <!-- <div routerLink="admin-settings" routerLinkActive="active" class="nav-item" placement="end"
          [ngbTooltip]="(isCollapsed ) ? 'admin-settings' : null">
          <p class="m-0 d-flex align-items-center ">
            <i class="ri-user-settings-line px-2"
              [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
            <span *ngIf="!isCollapsed || hoverExpanded">SSO Settings</span>
          </p>
        </div> -->
      </ng-container>

      <ng-container *ngIf="employee_details?.designation !== 'Caratred Supervisor'">
        <div routerLink="products" routerLinkActive="active" class="nav-item products-tab" placement="end"   (click)="closeSidebar()"
          [ngbTooltip]="(isCollapsed ) ? 'Products' : null">
          <p class="m-0 d-flex align-items-center ">
            <i class="ri-layout-grid-2-line px-2"
              [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
            <span *ngIf="!isCollapsed ">Products</span>
          </p>
        </div>
      </ng-container>

      <div routerLink="users" routerLinkActive="active" class="nav-item" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Employees' : null"  (click)="closeSidebar()">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-user-3-line px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Employees</span>
        </p>
      </div>

      <div routerLink="roles" routerLinkActive="active" class="nav-item" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Roles' : null"  (click)="closeSidebar()">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-id-card-fill px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Roles</span>
        </p>
      </div>

      <div routerLink="department" routerLinkActive="active" class="nav-item" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Department' : null"  (click)="closeSidebar()">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-git-merge-line px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Department</span>
        </p>
      </div>

      <!-- <div routerLink="permissions" routerLinkActive="active" class="nav-item" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Permissions' : null">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-key-fill px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Permissions</span>
        </p>
      </div> -->

      <div routerLink="settings" routerLinkActive="active" class="nav-item products-tab" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Settings' : null"  (click)="closeSidebar()">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-settings-4-line px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Settings</span>
        </p>
      </div>

      <div routerLink="workflow" routerLinkActive="active" class="nav-item" placement="end"
        [ngbTooltip]="(isCollapsed ) ? 'Workflow' : null"  (click)="closeSidebar()">
        <p class="m-0 d-flex align-items-center ">
          <i class="ri-flow-chart px-2"
            [ngClass]="{'mx-auto': isCollapsed && !hoverExpanded, 'me-2': !isCollapsed || hoverExpanded}"></i>
          <span *ngIf="!isCollapsed ">Workflow</span>
        </p>
      </div>

      <!-- Collapse toggle -->
      <div class="collapse-btn text-center " (click)="toggleSidebar()">
        <i [class]="isCollapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'"></i>
      </div>
    </div>
    <!-- Collapse Button -->
    <!-- <div class="collapse-btn text-center py-3 " (click)="toggleSidebar()">
      <i [class]="isCollapsed ? 'ri-menu-unfold-line' : 'ri-menu-fold-line'"></i>
    </div> -->
  </div>
  <!-- Main content -->
  <div class="content flex-grow-1">
    <router-outlet></router-outlet>
  </div>
</div>
<app-header  ></app-header>